/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Broker_Status_NewInputs */

const cs_ebr_broker_status_new = /** @type {(inputs: Ebr_Broker_Status_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nový uživatel`)
};

const en_ebr_broker_status_new = /** @type {(inputs: Ebr_Broker_Status_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New user`)
};

/**
* | output |
* | --- |
* | "New user" |
*
* @param {Ebr_Broker_Status_NewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_broker_status_new = /** @type {((inputs?: Ebr_Broker_Status_NewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Broker_Status_NewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_broker_status_new(inputs)
	return cs_ebr_broker_status_new(inputs)
});